import { useEffect, useState } from "react";
import { getAccountPaymentsAsync } from "./../../../../../services/paymentService";
import { getCurrencyAmount } from "../../../../../utils/stringUtils";
import Table from "./../../../../../components/common/Table";
import Pagination from "./../../../../../components/common/Pagination";
import moment from "moment";
import { IoCheckmark } from "react-icons/io5";

const PaymentsTable = ({ id, columns, tableOptions, onChange }) => {
  const [payments, setPayments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchPayments = async () => {
      setIsLoading(true);

      const response = await getAccountPaymentsAsync(id, tableOptions);
      const { result, page, total_count } = response;

      const data = result.map((item) => {
        const amount = getCurrencyAmount(item.amount);

        const created_on = (
          <>
            <p className="text-gray-500">
              {moment(item.created_on).format("LL")}
            </p>
            {item.is_sent && (
              <div className="flex items-center mt-1">
                <IoCheckmark className="mr-2" />
                <span className="text-xs text-gray-400">
                  Sent {moment(item.sent_on).fromNow()}
                </span>
              </div>
            )}
          </>
        );

        item["amount"] = <span>&#8369; {amount}</span>;
        item["reference_number"] = item.reference_number ?? "-";
        item["created_on"] = created_on;

        return item;
      });

      if (mounted) {
        setPayments(data);
        setCurrentPage(page);
        setTotalCount(total_count);
        setIsLoading(false);
      }
    };

    fetchPayments();

    return () => {
      mounted = false;
    };
  }, [id, tableOptions]);

  const handleSort = (sort_column) => {
    const options = { ...tableOptions };
    options.sort_column = sort_column;
    onChange(options);
  };

  const handlePageChange = (page) => {
    const options = { ...tableOptions };
    options.current_page = page;
    onChange(options);
  };

  return (
    <div className="overflow-auto lg:overflow-visible">
      <Table
        data={payments}
        columns={columns}
        sortColumn={tableOptions.sort_column}
        onSort={handleSort}
        isLoading={isLoading}
      />
      <Pagination
        itemsCount={totalCount}
        currentPage={currentPage}
        pageSize={tableOptions.page_size}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default PaymentsTable;
